/**
 * Exception list for not showing API error banner
 * 	Elements in this object sent as the parameter `requestType` in `apiRequest` are excluded
 * 	from showing the API Banner when there's an API call error
 */
export default { oktaUserUpdate: 'oktaUserUpdate' };
